/**
 * @generated SignedSource<<c6e460a26aee2693b751f2aede983be2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type sprintGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly sprint: {
    readonly state: JiraSprintState | null | undefined;
  };
  readonly " $fragmentType": "sprintGroupHeader_issueTableGrouping";
};
export type sprintGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: sprintGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"sprintGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sprintGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraSprint",
      "kind": "LinkedField",
      "name": "sprint",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "state"
        }
      ]
    }
  ],
  "type": "JiraJqlSprintFieldValue"
};

(node as any).hash = "8c878b1b3d9a4d86bbc1c264380dbce5";

export default node;
